function rgbToHex(r, g, b) {
  return `#${[r, g, b]
    .map((v) => Math.max(0, Math.min(255, v)).toString(16).padStart(2, '0'))
    .join('')}`.toUpperCase();
}

/** @returns {{ clientX: number, clientY: number } | null} */
export function getPointerClientCoords(event) {
  if (event?.changedTouches?.length) {
    return {
      clientX: event.changedTouches[0].clientX,
      clientY: event.changedTouches[0].clientY,
    };
  }
  if (typeof event?.clientX === 'number' && typeof event?.clientY === 'number') {
    return { clientX: event.clientX, clientY: event.clientY };
  }
  return null;
}

/**
 * Sample a hex color at a point on a displayed <img> (works on mobile; needs same-origin or blob URL).
 * @returns {string | null}
 */
export function sampleHexFromImageElement(img, clientX, clientY) {
  if (!img?.naturalWidth) return null;
  const rect = img.getBoundingClientRect();
  if (rect.width <= 0 || rect.height <= 0) return null;
  const relX = (clientX - rect.left) / rect.width;
  const relY = (clientY - rect.top) / rect.height;
  if (relX < 0 || relX > 1 || relY < 0 || relY > 1) return null;
  const x = Math.min(img.naturalWidth - 1, Math.max(0, Math.floor(relX * img.naturalWidth)));
  const y = Math.min(img.naturalHeight - 1, Math.max(0, Math.floor(relY * img.naturalHeight)));
  const canvas = document.createElement('canvas');
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  if (!ctx) return null;
  try {
    ctx.drawImage(img, 0, 0);
    const [r, g, b] = ctx.getImageData(x, y, 1, 1).data;
    return rgbToHex(r, g, b);
  } catch {
    return null;
  }
}

export function prefersPhotoColorPicker() {
  if (typeof window === 'undefined') return true;
  if (!window.EyeDropper) return true;
  try {
    return window.matchMedia('(pointer: coarse)').matches;
  } catch {
    return false;
  }
}
